import { useState, useEffect, useRef } from "react";
import { Volume2, Pause, Play, VolumeX } from "lucide-react";
import useSpeechSynthesis from "../hooks/useSpeechSynthesis";

const SpeechSynthesis = ({ displayText, onSelect, messageId }) => {
  const { speak, pause, resume, stop, isSpeaking, isPaused } =
    useSpeechSynthesis(onSelect);
  const [isToggling, setIsToggling] = useState(false);
  const previousTextRef = useRef(displayText);

  useEffect(() => {
    if (previousTextRef.current !== displayText && isSpeaking) {
      stop();
      requestAnimationFrame(() => speak(displayText));
    }
    previousTextRef.current = displayText;
  }, [displayText, isSpeaking, stop, speak]);

  const handlePlayPauseToggle = () => {
    if (isToggling) return;

    setIsToggling(true);
    onSelect(messageId);
    if (isSpeaking) {
      if (isPaused) {
        resume();
      } else {
        pause();
      }
    } else {
      speak(displayText);
    }
    setTimeout(() => setIsToggling(false), 300);
  };

  const handleStop = (e) => {
    e.stopPropagation();
    if (isToggling) return;

    setIsToggling(true);
    stop();
    onSelect(null);
    setTimeout(() => setIsToggling(false), 300);
  };

  return (
    <>
      <div className="flex justify-start mb-2 items-center gap-2">
        {isSpeaking && (
          <button
            onClick={handleStop}
            className={`p-1 border rounded transition ${
              isToggling ? "opacity-50" : "hover:bg-gray-100"
            }`}
            title="Stop"
            disabled={isToggling}
            aria-label="Stop speaking"
          >
            <VolumeX size={20} className="text-gray-700" />
          </button>
        )}

        <button
          onClick={handlePlayPauseToggle}
          className={`p-1 border rounded transition ${
            isToggling ? "opacity-50" : "hover:bg-gray-100"
          }`}
          title={isPaused ? "Resume" : isSpeaking ? "Pause" : "Read Aloud"}
          disabled={isToggling}
          aria-label={
            isPaused
              ? "Resume speaking"
              : isSpeaking
              ? "Pause speaking"
              : "Read aloud"
          }
        >
          {isPaused ? (
            <Play size={20} className="text-gray-700" />
          ) : isSpeaking ? (
            <Pause size={20} className="text-gray-700" />
          ) : (
            <Volume2 size={20} className="text-gray-700" />
          )}
        </button>
      </div>
    </>
  );
};

export default SpeechSynthesis;
